









































































import Vue from 'vue'
import Dialog from '@/components/Dialog.vue'
import Autocomplete from '@/components/Autocomplete.vue'
import IconButton from '~/components/IconButton.vue'
import FlatTable from '~/components/FlatTable.vue'
import ConfirmDialog from '~/components/ConfirmDialog.vue'
import {
  getProductProviderCodes,
  createOrUpdateProductProviderCode,
  deleteProductProviderCode,
} from '@/api/Topup/topup.api'
import { getAgencyProviders } from '@/utils/functions'
import {
  GetProductDTO,
  GetProductProviderCodeDTO,
} from '@/utils/interfaces/topup.interface'
import { Params, TableHeader, VueForm, VueTable } from '@/utils/interfaces'
import vRules from '~/utils/vRules'

export default Vue.extend({
  components: {
    appDialog: Dialog,
    appAutocomplete: Autocomplete,
    IconButton,
    FlatTable,
    ConfirmDialog,
  },
  props: {
    value: Boolean,
    product: {
      type: Object as () => GetProductDTO | null,
      default: null,
    },
  },
  data() {
    return {
      crud: {
        provider: '',
        code: '',
      } as { provider: string; code: string },
      editingUuid: null as string | null,
      saving: false,
      deleting: false,
      confirmDialog: false,
      deleteTarget: null as GetProductProviderCodeDTO | null,
      getAgencyProviders,
      rules: {
        required: vRules.required,
      },
      headers: [
        {
          text: this.$t('provider'),
          value: 'provider_name',
        },
        {
          text: this.$t('operator-code'),
          value: 'code',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader[],
    }
  },
  computed: {
    table(): VueTable {
      return this.$refs.table as VueTable
    },
  },
  methods: {
    getter(params?: Params) {
      return getProductProviderCodes({
        ...params,
        product__uuid: this.product ? this.product.uuid : undefined,
      })
    },
    resetForm() {
      this.editingUuid = null
      this.crud = { provider: '', code: '' }
      const form = this.$refs.form as VueForm
      if (form) form.resetValidation()
    },
    onEditRow(item: GetProductProviderCodeDTO) {
      this.editingUuid = item.uuid
      this.crud = { provider: item.provider, code: item.code }
    },
    onAskDelete(item: GetProductProviderCodeDTO) {
      this.deleteTarget = item
      this.confirmDialog = true
    },
    async onDelete(confirmed: boolean) {
      if (!confirmed || !this.deleteTarget) {
        this.deleteTarget = null
        return
      }
      try {
        this.deleting = true
        await deleteProductProviderCode(this.deleteTarget.uuid)
        if (this.editingUuid === this.deleteTarget.uuid) this.resetForm()
        this.table.removeItem(this.deleteTarget)
      } finally {
        this.deleting = false
        this.deleteTarget = null
      }
    },
    async onSave() {
      const form = this.$refs.form as VueForm
      if (!form.validate() || !this.product) return
      try {
        this.saving = true
        await createOrUpdateProductProviderCode({
          uuid: this.editingUuid || undefined,
          product: this.product.uuid,
          provider: this.crud.provider,
          code: this.crud.code,
        })
        this.resetForm()
        this.table.refresh()
      } finally {
        this.saving = false
      }
    },
  },
  watch: {
    value(value: boolean) {
      if (value) this.resetForm()
    },
  },
})
